<div id="page-auth" class="container text-center">
  <main>
    <img src="/assets/img/icon.png" class="logo" alt="logo">
    <div class="separator">Verificação de email</div>

    <div *ngIf="tokenValid == true">
      <div class="text-center">
        <h3>E-mail validado com sucesso!</h3>
        <a (click)="acessarConta()" class="cursor-pointer">Acessar minha conta</a>
        <br><br>
        <img src="../../../assets/img/undraw_happy_news.svg" alt="Ilustração simbolizando sucesso">
      </div>
    </div>

    <div *ngIf="tokenValid == false" class="text-center">
      <h3>Token não é válido, email <b>não</b> foi validado</h3>
      <a (click)="voltar()" class="cursor-pointer">Voltar</a>
      <br><br>
      <img src="../../../assets/img/undraw_page_not_found.svg" alt="Ilustração simbolizando não encontrado">
    </div>
  </main>
</div>